module.exports = __webpack_public_path__ + "assets/img/58_316.d278a723.jpg";